import { Link } from 'react-router-dom';
import { categories, type Manga } from '@/mocks/manga';

export default function MangaCard({ manga }: { manga: Manga }) {
  const categoryName = categories.find((c) => c.id === manga.categoryId)?.name ?? '漫画';
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={manga.cover}
          alt={`${manga.title}封面`}
          title={`${manga.title}日漫汉化`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
          {categoryName}
        </span>
        {manga.status === '已完结' && (
          <span className="absolute right-2 top-2 rounded-md bg-secondary-500 px-2 py-0.5 text-xs text-background-50">
            已完结
          </span>
        )}
        {manga.isNew && (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs text-background-50">
            NEW
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
          {manga.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{manga.author}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-amber-500"></i>
            {manga.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manga.views}
          </span>
        </div>
      </div>
    </Link>
  );
}